var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfxGeneratorUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 9.33325H11.9998C11.6462 9.33325 11.3071 9.47373 11.057 9.72378C10.807 9.97382 10.6665 10.313 10.6665 10.6666V21.3333C10.6665 21.6869 10.807 22.026 11.057 22.2761C11.3071 22.5261 11.6462 22.6666 11.9998 22.6666H19.9998C20.3535 22.6666 20.6926 22.5261 20.9426 22.2761C21.1927 22.026 21.3332 21.6869 21.3332 21.3333V13.3333M17.3332 9.33325L21.3332 13.3333M17.3332 9.33325L17.3332 13.3333H21.3332M15.9998 19.9999V15.9999M13.9998 17.9999H17.9998",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfxGeneratorUnselected);
export default __webpack_public_path__ + "static/media/rfx_generator_unselected.938a05631ccc879f07984512ba8228d9.svg";
export { ForwardRef as ReactComponent };